import React from "react";
import { Button } from "antd";
import { UploadOutlined, PlusOutlined } from "@ant-design/icons";

function PatientRecordHead(props) {
  return (
    <div className="row">
      <div
        className="col-md-3"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <img
          src="https://i.pinimg.com/originals/7e/50/a8/7e50a8ec377bd1d6edc3d613edcb17e5.jpg"
          style={{ width: 200, height: 200, borderRadius: 100 }}
          alt="User"
        />
      </div>
      <div className="col-md-7">
        <div className="row" style={{ fontSize: "3.5rem", fontWeight: "bold" }}>
          Chirag Dugar
        </div>
        <div className="row" style={{ marginTop: "3.5rem" }}>
          <span
            style={{ fontSize: "1.5rem", fontWeight: "bold", marginRight: 10 }}
          >
            DOB:
          </span>
          <span>2nd August, 2020</span>
        </div>
        <div className="row" style={{ marginTop: "1rem" }}>
          <span
            style={{ fontSize: "1.5rem", fontWeight: "bold", marginRight: 10 }}
          >
            Gender:
          </span>
          <span>Male</span>
        </div>
        <div className="row" style={{ marginTop: "1rem" }}>
          <span
            style={{ fontSize: "1.5rem", fontWeight: "bold", marginRight: 10 }}
          >
            Contact:
          </span>
          <span>+91 9677242899</span>
        </div>
        <div className="row"></div>
      </div>
      <div className="col-md-2">
        <div className="row" style={{ marginTop: "2rem" }}>
          <Button
            icon={
              <PlusOutlined
                style={{
                  fontWeight: "500",
                }}
              />
            }
            style={{
              backgroundColor: "#9254DE",
              color: "white",
              fontSize: "1.5rem",
              fontWeight: "500",
            }}
            onClick={() => props.props.history.push("/addprescription")}
          >
            Add Prescription
          </Button>
        </div>
        <div className="row" style={{ marginTop: "2rem" }}>
          <Button
            icon={
              <UploadOutlined
                style={{
                  fontWeight: "500",
                }}
              />
            }
            style={{
              backgroundColor: "#9254DE",
              color: "white",
              fontSize: "1.5rem",
              fontWeight: "500",
            }}
          >
            Upload Report
          </Button>
        </div>
      </div>
    </div>
  );
}

export default PatientRecordHead;
